

<div class="overflow-auto">

    <table class="w-100 table table-striped table-sm" style="font-size:12px;">
        <tr>
            <th>File Name</th>
            <th>Status</th>
            <th>Upload Start Date</th>
            <th>Upload Date</th>
            <th></th>
        </tr>
        <ng-container *ngFor="let localPhotoDoc of scoutPhotoUploadService.uploadNeededDocs" 
            [ngTemplateOutlet]="tableRow" 
            [ngTemplateOutletContext]="{ localPhotoDoc:localPhotoDoc, status: 'Not Uploaded' }">
        </ng-container>        
        <ng-container *ngFor="let localPhotoDoc of scoutPhotoUploadService.uploadingPhotoDocs" 
            [ngTemplateOutlet]="tableRow" 
            [ngTemplateOutletContext]="{ localPhotoDoc:localPhotoDoc, status: 'Uploading' }">
        </ng-container>        
        <ng-container *ngFor="let localPhotoDoc of scoutPhotoUploadService.errorPhotoDocs" 
            [ngTemplateOutlet]="tableRow" 
            [ngTemplateOutletContext]="{ localPhotoDoc:localPhotoDoc, status: 'Upload Error' }">
        </ng-container>        
    </table>

    <ng-template #tableRow let-localPhotoDoc="localPhotoDoc" let-status="status">
        <ng-container *ngIf="localPhotoDoc">
        <tr>
            <td class="text-nowrap">
                <a href="javascript:void;" (click)="toggleDetailsPanel(localPhotoDoc)">
                    {{localPhotoDoc.name}}&nbsp;
                    <i class="fa" [ngClass]="selectedPhotos[localPhotoDoc._id]?'fa-chevron-down':'fa-chevron-right'"></i>
                </a>
            </td>
            <td class="text-nowrap">
                {{status}}
            </td>
            <td class="text-nowrap">
                {{localPhotoDoc.uploadStartDate|date:'yyyy-MM-dd HH:mm:ss'}}
            </td>
            <td class="text-nowrap">
                {{localPhotoDoc.uploadDate|date:'yyyy-MM-dd HH:mm:ss'}}
                <button *ngIf="(localPhotoDoc.uploadDate&&localPhotoDoc.uploadStartDate)||localPhotoDoc.errorMsg"
                    class="btn btn-warning" (click)="retryUpload(localPhotoDoc)">
                    Resend
                </button>
            </td>
            <td class="w-100">
                <div *ngIf="localPhotoDoc.errorMsg">
                    Retry #{{localPhotoDoc.retryCnt}}
                    (delay={{(scoutPhotoUploadService.getDelayForRetryCntMs(localPhotoDoc.retryCnt)/60000)|number:'1.2'}} minutes)
                </div>
            </td>
        </tr>
        <tr *ngIf="selectedPhotos[localPhotoDoc._id] as selectedPhoto">
            <td colspan="4">
                <table class="w-100 m-0 p-0 table table-condensed table-sm">
                    <tr>
                        <th>Local Photo Document (cache)</th>
                    </tr>
                    <tr>
                        <td>
                            {{localPhotoDoc|json}}
                            <button class="btn btn-danger btn-sm" 
                            (click)=deleteLocalPhoto(localPhotoDoc)>
                                Delete
                            </button>
                        </td>
                    </tr>
                    <tr>
                        <th>Photo Document</th>
                    </tr>
                    <tr>
                        <td>
                            <div *ngIf="selectedPhoto.photoDoc$ | async as photoDoc">
                                <div *ngIf="photoDoc!==nullPhoto; else noPhotoDoc">
                                    {{photoDoc|json}}
                                    <button class="btn btn-secondary btn-sm" 
                                        (click)=showPhoto(photoDoc)>
                                        Edit
                                    </button>
                                </div>
                                <ng-template #noPhotoDoc>
                                    <div class="alert alert-danger">
                                        No RXDB photo found for local photo doc id
                                    </div>
                                </ng-template>
                            </div>
                            <div *ngIf="selectedPhoto.localPhotoUrlErr" class="alert alert-danger">
                                {{selectedPhoto.localPhotoUrlErr}}
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <th>Local Photo data URL (cache)</th>
                    </tr>
                    <tr>
                        <td>
                            <div *ngIf="selectedPhoto.localPhotoUrl$ | async as urlDoc">
                                <img *ngIf="urlDoc!==nullUrl; else noUrlDoc" [src]="urlDoc.url" class="w-100">
                                <ng-template #noUrlDoc>
                                    <div class="alert alert-danger">
                                        No local image data found for local RXDB photo doc id
                                    </div>
                                </ng-template>
                            </div>
                            <div *ngIf="selectedPhoto.localPhotoUrlErr" class="alert alert-danger">
                                {{selectedPhoto.localPhotoUrlErr}}
                            </div>
                        </td>
                    </tr>
                </table>
            </td>
        </tr>
        </ng-container>
        
    </ng-template>

</div>


